import {
  apiClient,
} from "./apiClient";

import type {
  DashboardMapFilters,
  DashboardMapResponse,
  DashboardOverview,
  DashboardRange,
  DashboardTrends,
} from "../types/dashboard.types";

/* =========================================================
 * Dashboard Overview
 * ======================================================= */

export async function getDashboardOverview(
  range: DashboardRange = "7d",
): Promise<DashboardOverview> {
  const params =
    new URLSearchParams();

  params.set(
    "range",
    range,
  );

  return apiClient.get<DashboardOverview>(
    `/dashboard/overview?${params.toString()}`,
  );
}

/* =========================================================
 * Dashboard Trends
 * ======================================================= */

export async function getDashboardTrends(
  range: DashboardRange = "30d",
): Promise<DashboardTrends> {
  const params =
    new URLSearchParams();

  params.set(
    "range",
    range,
  );

  return apiClient.get<DashboardTrends>(
    `/dashboard/trends?${params.toString()}`,
  );
}

/* =========================================================
 * Dashboard Map
 * ======================================================= */

export async function getDashboardMap(
  filters: DashboardMapFilters = {},
): Promise<DashboardMapResponse> {
  const params =
    new URLSearchParams();

  if (
    filters.accountType
  ) {
    params.set(
      "accountType",
      filters.accountType,
    );
  }

  if (
    filters.province
  ) {
    params.set(
      "province",
      filters.province,
    );
  }

  if (
    filters.limit !== undefined
  ) {
    params.set(
      "limit",
      String(
        filters.limit,
      ),
    );
  }

  const query =
    params.toString();

  return apiClient.get<DashboardMapResponse>(
    query
      ? `/dashboard/map?${query}`
      : "/dashboard/map",
  );
}